import { alpha, Theme, Components } from '@mui/material/styles';
import { gray } from '../themePrimitives';


export const surfacesCustomizations: Components<Theme> = {
  MuiAccordion: {
    defaultProps: {
      elevation: 0,
      disableGutters: true,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        padding: 4,
        overflow: 'clip',
        backgroundColor: theme.palette.background.default,
        border: '1px solid',
        borderColor: theme.palette.divider,
        ':before': {
          backgroundColor: 'transparent',
        },
        '&:not(:last-of-type)': {
          borderBottom: 'none',
        },
        '&:first-of-type': {
          borderTopLeftRadius: theme.shape.borderRadius,
          borderTopRightRadius: theme.shape.borderRadius,
        },
        '&:last-of-type': {
          borderBottomLeftRadius: theme.shape.borderRadius,
          borderBottomRightRadius: theme.shape.borderRadius,
        },
      }),
    },
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: ({ theme }) => ({
        border: 'none',
        borderRadius: 8,
        '&:hover': {
          backgroundColor: theme.palette.mode === 'light'
            ? alpha(gray[900], 0.04) // Hover très subtil
            : gray[50]
        },
        '&:focus-visible': { backgroundColor: 'transparent' },
        ...theme.applyStyles('dark', {
          '&:hover': { backgroundColor: gray[800] },
        }),
      }),
    },
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: { mb: 20, border: 'none' },
    },
  },
  MuiPaper: {
    defaultProps: {
      elevation: 0,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor: theme.palette.mode === 'light'
          ? 'hsl(0, 0%, 100%)' // Blanc pur pour les papers
          : theme.palette.background.paper,
        ...(theme.palette.mode === 'light' && {
          boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.05), 0px 1px 2px 0px rgba(0, 0, 0, 0.1)',
        }),
      }),
    },
  },
  MuiCard: {
    styleOverrides: {
      root: ({ theme }) => {
        return {
          padding: 16,
          gap: 16,
          transition: 'all 100ms ease',
          backgroundColor: theme.palette.mode === 'light' ? 'hsl(0, 0%, 100%)' : gray[800], // Blanc pur en light mode
          borderRadius: theme.shape.borderRadius,
          border: theme.palette.mode === 'light'
            ? `1px solid ${alpha(gray[900], 0.08)}` // Bordure très subtile
            : `1px solid ${theme.palette.divider}`,
          boxShadow: theme.palette.mode === 'light'
            ? '0px 1px 3px 0px rgba(0, 0, 0, 0.05), 0px 1px 2px 0px rgba(0, 0, 0, 0.1)' // Ombre très légère
            : 'none',
          ...theme.applyStyles('dark', {
            backgroundColor: gray[800],
            boxShadow: 'none',
          }),
          variants: [
            {
              props: {
                variant: 'outlined',
              },
              style: {
                border: theme.palette.mode === 'light'
                  ? `1px solid ${alpha(gray[900], 0.08)}`
                  : `1px solid ${theme.palette.divider}`,
                boxShadow: theme.palette.mode === 'light'
                  ? '0px 1px 3px 0px rgba(0, 0, 0, 0.05), 0px 1px 2px 0px rgba(0, 0, 0, 0.1)'
                  : 'none',
                background: theme.palette.mode === 'light' ? 'hsl(0, 0%, 100%)' : alpha(gray[900], 0.4),
                ...theme.applyStyles('dark', {
                  background: alpha(gray[900], 0.4),
                }),
              },
            },
          ],
        };
      },
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: 0,
        '&:last-child': { paddingBottom: 0 },
      },
    },
  },
  MuiCardHeader: {
    styleOverrides: {
      root: {
        padding: 0,
      },
    },
  },
  MuiCardActions: {
    styleOverrides: {
      root: {
        padding: 0,
      },
    },
  },
};

